import { formatMoneyDisplay } from "@common/lib/format";
import { type I18n, i18nFormat } from "@common/lib/i18n";

type GetTransferButtonCaptionArgs = {
  action: "transfer" | "withdraw";
  amount: number;
  balance: number;
  minTransferAmount: number;
  currencyCode: string;
};
export const getAccountButtonCaption = (i18n: I18n, data: GetTransferButtonCaptionArgs) => {
  const labels =
    data.action === "transfer"
      ? {
          cannotSubmit: i18n.infoMaxAmount,
          submit: i18n.transferAmount
        }
      : {
          cannotSubmit: i18n.infoMaxAmount,
          submit: i18n.withdrawAmount
        };

  return i18nFormat(
    data.amount && data.amount <= data.balance
      ? data.minTransferAmount > data.amount
        ? i18n.infoMinAmount
        : labels.submit
      : labels.cannotSubmit,
    ["AMOUNT", formatMoneyDisplay(data.amount, data.currencyCode)],
    ["MAX_AMOUNT", formatMoneyDisplay(data.balance, data.currencyCode)],
    ["MIN_AMOUNT", formatMoneyDisplay(data.minTransferAmount, data.currencyCode)]
  );
};
